export const AppRoutesUI = {
  Root: "/",

  Home: {
    Path: () => AppRoutesUI.Root + "home/",
    Route: "home",
  },
  Category: {
    Path: () => AppRoutesUI.Root + "category/",
    Route: "category",
  },
  CountryRegion: {
    Path: () => AppRoutesUI.Root + "country-region/",
    Route: "country-region",
  },
  ContentUpload: {
    Path: () => AppRoutesUI.Root + "content-upload/",
    Route: "content-upload",
  },
  ContentUploadCountry: {
    Path: () => AppRoutesUI.Root + "content-upload/",
    Route: ":countryId",
  },
  Forms: {
    Path: () => AppRoutesUI.Root + "forms/",
    Route: "forms",
  },
  Regulations: {
    Path: () => AppRoutesUI.Root + "regulations/",
    Route: "regulations",
  },
  NewsAggregator: {
    Path: () => AppRoutesUI.Root + "newsaggregator/",
    Route: "newsaggregator",
  },
  MLIDataUploader: {
    Path: () => AppRoutesUI.Root + "MLIData/",
    Route: "MLIData",
  },
  Auth: {
    Path: () => AppRoutesUI.Root + "auth/",
    Route: "auth",
    Login: { Path: () => AppRoutesUI.Auth.Path() + "login/", Route: "login" },
    SignUp: {
      Path: () => AppRoutesUI.Auth.Path() + "signUp/",
      Route: "signUp",
    },
  },
  NotFound: {
    Path: () => AppRoutesUI.Root + "404/",
    Route: "404",
  },
};
